import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=4ecae6c2&scoped=true"
import script from "./Connection.vue?vue&type=script&lang=js"
export * from "./Connection.vue?vue&type=script&lang=js"
import style0 from "./Connection.vue?vue&type=style&index=0&id=4ecae6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecae6c2",
  null
  
)

export default component.exports